export default "__VITE_ASSET__CLn5gt$u__"